import { styled } from '@mui/material';
import { getMimeFromFileExtension } from '~/lib/file';
import DocSvg from './doc.svg?react';
import JpgSvg from './jpg.svg?react';
import PdfSvg from './pdf.svg?react';
import PngSvg from './png.svg?react';
import PptSvg from './ppt.svg?react';
import TxtSvg from './txt.svg?react';
import UnknownFileSvg from './unknownFile.svg?react';
import XlsSvg from './xls.svg?react';

export interface FileIconProps {
  mimeType: string;
}

const getIconSvg = (mimeType: string): React.FC<React.SVGProps<SVGSVGElement>> => {
  switch (mimeType) {
    case getMimeFromFileExtension('doc'):
    case getMimeFromFileExtension('docx'):
      return DocSvg;
    case getMimeFromFileExtension('ppt'):
    case getMimeFromFileExtension('pptx'):
      return PptSvg;
    case getMimeFromFileExtension('xls'):
    case getMimeFromFileExtension('xlsx'):
      return XlsSvg;
    case getMimeFromFileExtension('txt'):
      return TxtSvg;
    case getMimeFromFileExtension('jpg'):
      return JpgSvg;
    case getMimeFromFileExtension('png'):
      return PngSvg;
    case getMimeFromFileExtension('pdf'):
      return PdfSvg;
    default:
      return UnknownFileSvg;
  }
};

const Container = styled('div')`
  height: 2.2rem;

  svg {
    height: 100%;
  }
`;

const FileIcon: React.FC<FileIconProps> = ({ mimeType }) => {
  const IconSvg = getIconSvg(mimeType);

  return (
    <Container>
      <IconSvg />
    </Container>
  );
};

export default FileIcon;
